import { render, staticRenderFns } from "./TripEditDialog.vue?vue&type=template&id=28cd8d0c"
import script from "./TripEditDialog.vue?vue&type=script&lang=js"
export * from "./TripEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports